import { vanillaRenderers } from '@jsonforms/vanilla-renderers'
import { once } from 'radashi'

import { getRegistry } from '../blocks-renderers'

// eslint-disable-next-line no-console
const infoOnce = once(console.info)

export const getRenderers = (): ReturnType<typeof getRegistry> => {
  const wrappedVanillaRenderers = vanillaRenderers.reduce<
    typeof vanillaRenderers
  >((acc, item) => {
    acc.push({
      tester: item.tester,
      renderer: (...args: unknown[]) => {
        infoOnce('JSON Forms is rendering a vanilla renderer', item)

        return item.renderer(...args)
      }
    })

    return acc
  }, [])

  return wrappedVanillaRenderers.concat(getRegistry())
}
